import { defineComponent as g, computed as $, h as t } from "vue";
function u(e, c, i = 100) {
  return `m ${i / 2} ${i / 2 - e} a ${e} ${e} 0 1 1 0 ${2 * e} a ${e} ${e} 0 1 1 0 -${2 * e}`;
}
const m = g({
  name: "ProgressMultipleCircle",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    viewBoxWidth: {
      type: Number,
      required: !0
    },
    percentage: {
      type: Array,
      default: [0]
    },
    strokeWidth: {
      type: Number,
      required: !0
    },
    circleGap: {
      type: Number,
      required: !0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    fillColor: {
      type: Array,
      default: () => []
    },
    railColor: {
      type: Array,
      default: () => []
    },
    railStyle: {
      type: Array,
      default: () => []
    }
  },
  setup(e, {
    slots: c
  }) {
    const i = $(() => e.percentage.map((a, o) => `${Math.PI * a / 100 * (e.viewBoxWidth / 2 - e.strokeWidth / 2 * (1 + 2 * o) - e.circleGap * o) * 2}, ${e.viewBoxWidth * 8}`));
    return () => {
      const {
        viewBoxWidth: l,
        strokeWidth: a,
        circleGap: o,
        showIndicator: p,
        fillColor: n,
        railColor: d,
        railStyle: h,
        percentage: f,
        clsPrefix: s
      } = e;
      return t("div", {
        class: `${s}-progress-content`,
        role: "none"
      }, t("div", {
        class: `${s}-progress-graph`,
        "aria-hidden": !0
      }, t("div", {
        class: `${s}-progress-graph-circle`
      }, t("svg", {
        viewBox: `0 0 ${l} ${l}`
      }, f.map((y, r) => t("g", {
        key: r
      }, t("path", {
        class: `${s}-progress-graph-circle-rail`,
        d: u(l / 2 - a / 2 * (1 + 2 * r) - o * r, a, l),
        "stroke-width": a,
        "stroke-linecap": "round",
        fill: "none",
        style: [{
          strokeDashoffset: 0,
          stroke: d[r]
        }, h[r]]
      }), t("path", {
        class: [`${s}-progress-graph-circle-fill`, y === 0 && `${s}-progress-graph-circle-fill--empty`],
        d: u(l / 2 - a / 2 * (1 + 2 * r) - o * r, a, l),
        "stroke-width": a,
        "stroke-linecap": "round",
        fill: "none",
        style: {
          strokeDasharray: i.value[r],
          strokeDashoffset: 0,
          stroke: n[r]
        }
      })))))), p && c.default ? t("div", null, t("div", {
        class: `${s}-progress-text`
      }, c.default())) : null);
    };
  }
});
export {
  m as default
};
